import Swiper from "swiper";
import {Navigation, Pagination} from 'swiper/modules';

// Event buttons
const eventButtons = document.querySelectorAll('.event-button');
const eventImages = document.querySelectorAll('.event-image');
const eventTitles = document.querySelectorAll('.event-title');
const eventDescriptions = document.querySelectorAll('.event-description');
const candidatesEventLink = document.querySelectorAll('.candidates-event-link');
const sliderImages = document.querySelectorAll('.slider-img');
const sliderButtons = document.querySelectorAll('.slider-button');

eventButtons.forEach(button => {
	button.addEventListener('click', () => {
		if(button.classList.contains('active')) {
			return;
		}
		
		eventButtons.forEach(btn => btn.classList.remove('active'));
		button.classList.add('active');
		
		const targetEvent = button.getAttribute('data-event-target');
		
		eventImages.forEach(image => {
			if(image.getAttribute('data-event-target') === targetEvent) {
                
				image.classList.remove('hidden');
			} else {
				image.classList.add('hidden');
			}
		});

		eventTitles.forEach(title => {
			if(title.getAttribute('data-event-target') === targetEvent) {
				title.classList.remove('hidden');
			} else {
				title.classList.add('hidden');
			}
		});

		eventDescriptions.forEach(description => {
			if(description.getAttribute('data-event-target') === targetEvent) {
				description.classList.remove('hidden');
			} else {
				description.classList.add('hidden');
			}
		});

		candidatesEventLink.forEach(link => {
			if(link.getAttribute('data-event-target') === targetEvent) {
				link.classList.remove('hidden');
			} else {
				link.classList.add('hidden');
			}
		});
	});
});

// Swiper 
document.addEventListener('DOMContentLoaded', () => {
    var swiper = new Swiper(".eventSwiper", {
        modules: [Navigation, Pagination],
        cssMode: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: ".swiper-pagination",
		  clickable: true,
		  renderBullet: function (index, className) {
			  return '<span class="' + className + '">' + '</span>';
		  }
        },
        mousewheel: true,
        keyboard: true,
      });

	  var swiperDesktop = new Swiper(".eventSwiper-desktop", {
		modules: [Navigation, Pagination],
		cssMode: true,
		navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
		},
		pagination: {
			el: ".swiper-pagination",
			clickable: true,
		},
		
	  });
});

// Swipe slider
sliderButtons.forEach(button => {
	button.addEventListener('click', () => {
		const targetEvent = button.getAttribute('data-event-target');
		sliderImages.forEach(image => {
			if(image.getAttribute('data-event-target') === targetEvent) {
				image.classList.remove('hidden');
			} else {
				image.classList.add('hidden');
			}
		});
	});
});
